var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"github-corner",attrs:{"href":"https://github.com/codysherman/2nfm","target":"_blank","rel":"noopener"}},[_c('GitHubSvg')],1)}
var staticRenderFns = []

export { render, staticRenderFns }